window.VVCART = window.VVCART || {
  selectors: {
    image: '.vv_cart_item_row .page_cart_info img',
  },
  targets: [],
  run: loadVVCARTLibraries,
};

window.VVCART.debug = false;

function observeVVCARTItemImages() {
  const debug = VVCART.debug;
  debug && console.log('VVCART | DEBUG | Observing Item Images');

  const launchZoom = (e) => {
    let img = event.target;

    if (img.nodeName !== 'IMG') {
      return;
    }

    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();

    let zoom = VVCART.targets[img.src] || mediumZoom(img, {background: '#000000AA'});
    if (zoom) {
      VVCART.targets[img.src] = zoom;
      zoom.open();
    }
  }

  $(document)
    .off('click.vvcart', VVCART.selectors.image, launchZoom)
    .on('click.vvcart', VVCART.selectors.image, launchZoom);
}

function initVVCART() {
  if (!window.mediumZoom) {
    console.log('VVCART | ERROR | medium-zoom loaded | Abort');
    return;
  }

  observeVVCARTItemImages();
}

async function loadVVCARTLibraries() {
  if (!window.mediumZoom) {
    addVVCARTScript('https://unpkg.com/medium-zoom@1.0.6/dist/medium-zoom.min.js', 'medium-zoom', () => {
      initVVCART();
    });
  } else {
    initVVCART();
  }
}

function addVVCARTScript(src, id, callback) {
  if (document.getElementById(id)) {
    callback && callback();
    return;
  }

  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = src;
  s.id = id;
  s.onload = () => { callback && callback() };
  document.body.appendChild(s);
}

if (/complete|interactive|loaded/.test(document.readyState)) {
  window.VVCART.run();
} else {
  document.addEventListener('DOMContentLoaded', window.VVCART.run, false);
}

/*
PROBLEMS / PENDING

*/